module.exports = __webpack_public_path__ + "img/logo-with-text.c38638cb.svg";